module.exports = __webpack_public_path__ + "img/icon-share.7073fea.svg";